module.exports = __webpack_public_path__ + "img/guagnzhou3.4419546a.jpg";